import shareTip from './shareTip';
import createInstance from '../index';

export default createInstance(shareTip);
